export const getEventPrice = (Original: number, Negociate: number): string => {
  if (Negociate === 0) return `${Original}`;
  return `${Negociate}`;
};
